(function (upp) {
    'use strict';

    upp.directive('catalogFilters', function () {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: require('../templates/catalog-filters.html'),
            controller: ['$scope', '$element', '$attrs', 'productsCategoriesService',
                function ($scope, $element, $attrs, productsCategoriesService) {
                    $scope.applyFilters = function () {
                        // TODO: use callback
                        $scope.filterProducts();
                        $scope.showFilters = false;
                    };

                    /**
                     * Fired whe a category filter is selected
                     * Load the subcategories
                     * @method selectCategory
                     * @param {Object} category
                     */
                    $scope.selectCategory = function (category) {
                        if (category && category.id) {
                            //subcategories
                            $scope.subcategories = undefined;
                            productsCategoriesService.listChildrenOfParent(category.id)
                                .then(function (response) {
                                    if (response.data.length) {
                                        $scope.subcategories = response.data;
                                        // preselect the element
                                        if ($scope.filters.subcategory && $scope.filters.subcategory.id > 0) {
                                            var find = $scope.subcategories.find(function(elem) {
                                                return elem.id == $scope.filters.subcategory.id;
                                            });

                                            if (find) {
                                                $scope.filters.subcategory = find;
                                            }else{
                                                $scope.filters.subcategory = undefined;
                                            }
                                        }
                                    }
                                });
                        }
                    };


                    /**
                     * Set the order of the products
                     * - -1 => Default order (the order the creator selected)
                     * - 0 => DESC by price
                     * - 1 => ASC by price
                     * @param _order
                     */
                    $scope.setOrder = function (_order) {
                        switch (_order) {
                            case 'ASC':
                                $scope.filters.order = 1;
                                break;
                            case 'DESC':
                                $scope.filters.order = 0;
                                break;
                            default:
                                $scope.filters.order = -1;
                        }
                    };

                    /**
                     * Reset all the filters
                     */
                    $scope.resetFilters = function () {
                        $scope.filters = {};
                        $scope.priceFilter = '';
                        // TODO: use callback
                        $scope.filterProducts();
                    };

                    // Categories
                    productsCategoriesService.listParents()
                        .then(function (response) {
                            if (response.data.length) {
                                $scope.categories = response.data;
                                // preselect the element
                                if ($scope.filters.category && $scope.filters.category.id > 0) {
                                    var find = $scope.categories.find(function(elem) {
                                        return elem.id == $scope.filters.category.id;
                                    });

                                    if (find) {
                                        $scope.filters.category = find;
                                        $scope.selectCategory($scope.filters.category);
                                    }
                                }
                            }
                        });
                }]
        };
    });

}(window.upp));



// WEBPACK FOOTER //
// ./src/app/modules/eshop/directives/catalog-filters-directive.js